import * as React from 'react';
import { observer } from 'mobx-react-lite';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { getOnlineMeetingProviderInfo } from 'owa-online-meeting';
import getOnlineMeetingProviderSelector from './OnlineMeetingProviderSelector';
import type { ITheme } from '@fluentui/react/lib/Styling';
import OnlineMeetingLink from 'owa-online-meeting/lib/component/OnlineMeetingLink';

export interface OnlineMeetingElementProps {
    formId: string;
    event: CalendarEvent;
    calendarColorScheme: ColorScheme;
    theme: ITheme;
    isDarkMode?: boolean;
    compactMode?: Boolean;
    dropdownContainerClassName?: string;
    hideDropdownTitleIcon?: boolean;
    disabled?: boolean;
    hideLinkIcon?: boolean;
    joinOnlineLinkContainerClassName?: string;
    joinOnlineLinkClassName?: string;
    onLinkClickedCallback?: () => void;
}

const OnlineMeetingElement: React.FunctionComponent<OnlineMeetingElementProps> = observer(props => {
    const {
        event,
        calendarColorScheme,
        theme,
        isDarkMode,
        compactMode = false,
        dropdownContainerClassName,
        hideDropdownTitleIcon,
        disabled,
        hideLinkIcon,
        joinOnlineLinkContainerClassName,
        joinOnlineLinkClassName,
        formId,
        onLinkClickedCallback,
    } = props;

    if (event.IsOnlineMeeting && event.OnlineMeetingJoinUrl) {
        return (
            <OnlineMeetingLink
                calendarColorScheme={calendarColorScheme}
                event={event}
                hideIcon={hideLinkIcon}
                joinOnlineLinkContainerClassName={joinOnlineLinkContainerClassName}
                joinOnlineLinkClassName={joinOnlineLinkClassName}
                onLinkClickedCallback={onLinkClickedCallback}
            />
        );
    } else {
        const onlineMeetingProviders = getOnlineMeetingProviderInfo(event);
        return onlineMeetingProviders
            ? getOnlineMeetingProviderSelector(
                  onlineMeetingProviders,
                  theme,
                  event,
                  calendarColorScheme,
                  formId,
                  compactMode,
                  isDarkMode,
                  dropdownContainerClassName,
                  hideDropdownTitleIcon,
                  disabled
              )
            : null;
    }
});

export default OnlineMeetingElement;
